<template>
    <div>
        <MqResponsive target="md+">
            <div class="row" style="width:100%">
                <div class="col header-title-parent">
                    <div class="header-title font-KiaSignatureBold">
                        <h2>{{ headerTitle }}</h2>
                    </div>
                </div>
                <div class="col">
                    <div class="app-logo">
                        <img src="customscripts/logo-main.png" width="300">
                    </div>
                </div>
                <div class="col">
                </div>
            </div>
        </MqResponsive>
        <MqResponsive target="sm-">
            <div class="app-logo">
                <img src="customscripts/logo-main.png" width="200">
            </div>
        </MqResponsive>
        <div class="mainform" style="">
            <b-card v-if="!orederItem" class="input-main-form mb-2" style="max-width: 30em; margin:auto; border:0px">
                <div>
                    <label for="fullName" class="label font-KiaSignatureBold">Full Name </label>
                    <b-form-input class="font-KiaSignatureBold" v-model="lastName" id="fullName"></b-form-input>
                </div>
                <div>
                    <label for="order" class="label font-KiaSignatureBold">VIN # (LAST 6)</label>
                    <b-form-input class="font-KiaSignatureBold" v-model="order" id="vin"></b-form-input>
                </div>
                <div v-if="!loading">
                    <b-button class="button font-KiaSignatureBold" v-on:click="showData">Show</b-button>
                </div>
                <div v-if="loading">
                    <b-button class="button font-KiaSignatureBold" disabled>
                        <b-spinner small type="grow"></b-spinner>
                        Show
                    </b-button>
                </div>
            </b-card>
            <div class="order-details">
                <div v-if="pressed && !orederItem" style="max-width: 25em; margin:auto">
                    <b-alert show variant="danger">{{ errorMessage }}</b-alert>
                </div>
                <div v-if="orederItem">
                    <div class="status-background"
                        v-bind:style="{ backgroundImage: 'url(' + getBacgkground(selectedStatus) + ')' }">
                        <MqResponsive target="md+">
                            <div class="row" style="width:100%">
                                <div class="col header-title-parent">
                                    <div class="header-title font-KiaSignatureBold">
                                        <h2>{{ headerTitle }}</h2>
                                    </div>
                                </div>
                                <div class="col">
                                    <div class="app-logo">
                                        <img src="customscripts/logo-main.png" width="300">
                                    </div>
                                </div>
                                <div class="col">
                                </div>
                            </div>
                        </MqResponsive>
                        <MqResponsive target="sm-">
                            <div class="app-logo">
                                <img src="customscripts/logo-main.png" width="200">
                            </div>
                        </MqResponsive>
                        <b-card style="max-width: 60em; margin:auto" class="mb-2">
                            <div class="font-KiaSignatureRegular">
                                <h2>
                                    <MqResponsive target="md+">
                                        {{ orederItem.customerName }}'s {{ orederItem.modelYear }} {{
                                                orederItem.modelDescription
                                        }} in {{ orederItem.color }}
                                    </MqResponsive>
                                    <MqResponsive target="sm-">
                                        <p>{{ orederItem.customerName }}'s</p>
                                        <p>{{ orederItem.modelYear }} {{ orederItem.modelDescription }} in {{
                                                orederItem.color
                                        }}</p>
                                    </MqResponsive>
                                </h2>
                            </div>
                            <div class="sold-order-vin font-type-regular">
                                <h3>
                                    VIN {{ orederItem.vin2 }}
                                </h3>
                            </div>
                            <MqResponsive target="sm-">
                                <div class="timeline font-KiaSignatureRegular">
                                    <div class="swiper-slide" v-for="item in statuses">
                                        <div v-if="!item.selected">
                                            <div class="status small">
                                                <span>{{ item.title }}</span>
                                            </div>
                                        </div>
                                        <div v-if="item.selected">
                                            <div class="status small selected">
                                                <span>{{ item.title }}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </MqResponsive>
                            <MqResponsive target="md+">
                                <div class="timeline font-KiaSignatureRegular">
                                    <div class="swiper-slide" v-for="item in statuses">
                                        <div v-if="!item.selected">
                                            <div class="status">
                                                <span>{{ item.title }}</span>
                                            </div>
                                        </div>
                                        <div v-if="item.selected">
                                            <div class="status selected">
                                                <span>{{ item.title }}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </MqResponsive>
                            <div class="font-KiaSignatureRegular">
                                <h3>
                                    <MqResponsive target="sm-">
                                        <p>Current Status: </p>
                                        <p style="display: inline" class="order-status-value">{{ selectedStatus }}</p>
                                    </MqResponsive>
                                    <MqResponsive target="md+">
                                        Current Status:
                                        <p style="display: inline" class="order-status-value">{{ selectedStatus }}</p>
                                    </MqResponsive>
                                </h3>
                            </div>
                            <div class="font-KiaSignatureRegular">
                                <h3>
                                    {{ etaString }}
                                </h3>
                            </div>
                            <div class="font-KiaSignatureRegular updated-date">
                                <h3>
                                    Last Updated: {{ updatedDate }}
                                </h3>
                            </div>
                            <div>
                                <div class="what-does-each-status-mean-section">
                                    <b-tabs content-class="mt-3 what-does-each-status-mean-body" fill
                                        title-item-class="tab-title-class"
                                        v-model="tabSelectedStatus"
                                        >
                                        <b-tab v-for="status in statuses" v-bind:key="status" :title="status.title">
                                            <p>{{ status.description }}</p>
                                        </b-tab>
                                    </b-tabs>
                                </div>
                            </div>
                        </b-card>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import moment from "moment";
import { MqResponsive } from "vue3-mq";

export default {
    name: 'main-component',
    components: {
        MqResponsive
    },
    data() {
        return {
            lastName: '',
            order: '',
            orederItem: null,
            pressed: false,
            loading: false,
            headerTitle: 'Sold Order Tracking',
            statuses: [],
            selectedStatus: '',
            updatedDate: '',
            errorMessage: '',
            etaString: '',
            tabSelectedStatus: 0
        }
    },
    methods: {
        getStatus(item) {
            return item.status;
        },
        getBacgkground(item) {
            switch (item) {
                case 'VPC':
                    return 'customscripts/background-image.jpg';
                case 'At Sea':
                    return 'customscripts/at_sea.jpg';
                case 'At Port':
                    return 'customscripts/at_port.jpg';
                case 'In Transit':
                    return 'customscripts/in_transit.jpg';
                case 'Compound':
                    return 'customscripts/compound.jpg';
            }

            return 'customscripts/background-image.jpg';
        },
        initStatuses(status) {
            this.statuses = [
                {
                    title: 'VPC',
                    description: 'It’s a KIA! Your vehicle’s been born. It has a serial number and is parked awaiting pickup to begin its journey to you.'
                },
                {
                    title: 'At Sea',
                    description: 'Kia manufactures vehicles across the globe. For our customers, vehicles are manufactured in North America or in South Korea. If your VIN begins with K, ‘At Sea’ will mean your vehicle is making its way across the pacific; if it begins with a number, it means your vehicle is en route from south of the border.'
                },
                {
                    title: 'At Port',
                    description: 'Your vehicle will only land in ‘At Port’ status if it’s been shipped from South Korea. This means your vehicle is inside a container at the Vancouver shipping port awaiting ground transportation pickup.'
                },
                {
                    title: 'In Transit',
                    description: 'Tens of thousands of Kia vehicles make their way to their new Canadian driveways by crossing the mountains, plains and valleys of our beautiful country. Your vehicle is among them and will travel by train and truck before reaching a compound near you. \n\n Now would be a great time to ensure you’ve reviewed all accessories available for your vehicle and ordered anything you’d like to have when your vehicle arrives. Please contact your Product Advisor for details on available accessories for your vehicle.'
                },
                {
                    title: 'Compound',
                    description: 'One last boat ride to our rugged, pine-clad hills stands between you and your new Kia.'
                }
            ];

            for (let i = 0; i < this.statuses.length; i++) {
                if (this.statuses[i].title.toLowerCase() == status.toLowerCase()) {
                    this.statuses[i].selected = true;
                    this.selectedStatus = this.statuses[i].title;
                }
            }
        },
        getStatus(input) {
            if (input == 'Port') {
                return 'At Port';
            }
            return input
        },
        async showData() {
            this.orederItem = null;
            if (this.order.trim().length != 6) {
                this.errorMessage = "VIN field should be last 6"
            }
            else {
                this.errorMessage = ""
                this.loading = true;
                try {
                    let url = `${window.baseUrl}api/Data/${this.lastName.trim()}/${this.order.trim()}/${window.dns}`;
                    const response = await fetch(url);

                    this.orederItem = await response.json();
                    console.log('orederItem');
                    console.log(this.orederItem);
                    this.orederItem = {
                        status: this.orederItem.location,
                        customerName: this.orederItem.customerName,
                        modelYear: this.orederItem.modelYear,
                        modelDescription: this.orederItem.description,
                        color: this.orederItem.ext,
                        eta: this.orederItem.eta,
                        vin2: this.orederItem.vin2
                    };

                    var status = this.getStatus(this.orederItem.status);

                    this.updatedDate = moment(this.orederItem.updatedDate).format("MMMM DD");

                    if (this.orederItem.eta) {
                        this.etaString = `ETA: ${moment(this.orederItem.eta).format("MMMM DD, YYYY")}`;
                    }

                    this.initStatuses(status);

                    let foudnIndex = 0;
                    for (let i=0; i< this.statuses.length; i++) {
                        if (this.statuses[i].title.toLowerCase() == status.toLowerCase()) {
                            foudnIndex = i;
                        }
                    }
                    if (foudnIndex >= 0) {
                        this.tabSelectedStatus = foudnIndex; 
                    }
                } catch (error) {
                    console.error(error);
                } finally {
                    this.errorMessage = "Not found"
                    this.loading = false;
                }
            }

            this.pressed = true;
        }
    }
}
</script>

<style scoped>
@media (max-width: 400px) {
    .small-size {
        margin-top: 200px;
    }
}

.status-background {
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    position: absolute;
}

.font-KiaSignatureBold {
    font-family: KiaSignatureBold, Avenir, Helvetica, Arial, sans-serif;
}

.font-KiaSignatureLight {
    font-family: KiaSignatureLight, Avenir, Helvetica, Arial, sans-serif;
}

.font-KiaSignatureRegular {
    font-family: KiaSignatureRegular, Avenir, Helvetica, Arial, sans-serif;
}

.updated-date {
    color: #808285;
    margin-top: 20px;
}

.order-details .sold-order-status h3 {
    font-weight: bold !important;
}

.order-status-value {
    color: #136FC2;
}

.order-details {
    text-align: center;
    color: #2F3D48;
}

.order-details .card {
    border: 0px;
}

.header-title-parent {
    position: relative;
    color: #FFFFFF;
}

.header-title {
    left: 50px;
    position: absolute;
    top: 35%;
}

.app-logo {
    text-align: center;
}

.input-main-form {
    color: #ffffff;
}

.input-main-form .button {
    width: 100%;
    margin-top: 25px;
}

.input-main-form .title {
    padding-bottom: 5px;
}

.input-main-form .label {
    margin-top: 20px;
    padding-bottom: 10px;
}

.form-control {
    background: transparent;
    color: #ffffff;
    border-color: #ffffff;
    border-radius: 7px;
}

.form-control:focus {
    background: transparent;
    color: #ffffff;
    border-color: #ffffff;
    border-radius: 7px;
}

.card.input-main-form {
    background: transparent;
    border-radius: 1.2em;
    padding: 20px;
}

body {
    background: #e8eeff;
}

#app {
    padding: 50px 0;
}

.timeline {
    margin: 70px 0;
    list-style-type: none;
    display: flex;
    padding: 0;
    text-align: center;
}

.status.small {
    padding: 0px 10px;
}

.status {
    padding: 0px 40px;
    display: flex;
    justify-content: center;
    border-top: 5px solid #000000;
    position: relative;
    transition: all 200ms ease-in;
}

/* #25527c */

.status.selected {
    border-top: 5px solid #000000;
    font-weight: bolder;
}

.status.selected span {
    font-weight: 1000;
}

.status span {
    padding-top: 20px;
}

.status.selected span:before {
    content: '';
    width: 26px;
    height: 26px;
    background-color: #ffffff;
    border-radius: 26px;
    border: 13px solid #000000;
    position: absolute;
    top: -15px;
    left: 42%;
    transition: all 200ms ease-in;
}

.swiper-slide {
    width: 20%;
}

.mainform {
    margin-top: 20px;
}

.expando-btn {
    background-color: #e5e6e8;
    border-color: #e5e6e8;
    border-radius: 0px;
    color: black;
    width: 90%;
    padding-top: 10px;
}

.expando-btn:hover {
    background-color: #e5e6e8;
    border-color: #e5e6e8;
    border-radius: 0px;
    color: black;
    width: 90%;
    padding-top: 10px;
}

.expando-btn:focus {
    background-color: #e5e6e8;
    border-color: #e5e6e8;
    border-radius: 0px;
    color: black;
    width: 90%;
    padding-top: 10px;
}

/* #136FC2 */

/* #2F3D48 */
</style>
